import moment from "moment";
import Vue from "vue";

const state = () => ({
  timesheetRecords: [],
  lastFetched: null,
});

const getters = {
  timesheetRecords: (state) => {
    return state.timesheetRecords;
  },
  lastClockinRecord: (state) => {
    const today = moment().startOf("day");
    const todayRecords = state.timesheetRecords
      .filter((record) => moment(record.timeIn).isSame(today, "day"))
      .sort((a, b) => moment(b.timeIn).diff(moment(a.timeIn)));

    if (todayRecords.length > 0) {
      return todayRecords[0];
    } else {
      return null;
    }
  },
  isClockedIn: (state) => {
    const today = moment().startOf("day");
    const todayRecords = state.timesheetRecords
      .filter((record) => moment(record.timeIn).isSame(today, "day"))
      .sort((a, b) => moment(b.timeIn).diff(moment(a.timeIn)));

    if (todayRecords.length > 0) {
      const lastRecord = todayRecords[0];

      return !lastRecord.timeOut;
    }

    return false;
  },
  hasExpired: (state) => {
    const now = moment();
    if (!state.lastFetched || now.diff(state.lastFetched, "minutes") > 5) {
      return true;
    } else {
      return false;
    }
  },
};

const actions = {
  async fetchTimesheetRecords({ commit }) {
    const records = await Vue.axios
      .get("/timesheet/my-records")
      .then((resp) => {
        const records = resp.data;
        // add a date field to each record
        return records.map((r) => {
          r.date = moment(r.timeIn).format("YYYY-MM-DD");
          return r;
        });
      });

    commit("setTimesheetRecords", records);
  },
};

const mutations = {
  setTimesheetRecords(state, records) {
    state.timesheetRecords = records;
    state.lastFetched = moment();
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
